<div class="lv-uiartefakt-container-header-group">
  <div *ngIf="!!text" class="lv-uiartefakt-container-header-tag" [innerHTML]="text"></div>
  <div class="lv-uiartefakt-container-header">
    <div>
      <mat-icon class="lv-card-layout-ui-container-icon" [svgIcon]="cardIcon"></mat-icon>
    </div>
    <div class="lv-uiartefakt-container-header-titel" [innerHTML]="titel"></div>
  </div>
</div>
